import { render, staticRenderFns } from "./Authorize.vue?vue&type=template&id=06cb1a6e&scoped=true&"
import script from "./Authorize.vue?vue&type=script&lang=js&"
export * from "./Authorize.vue?vue&type=script&lang=js&"
import style0 from "./Authorize.vue?vue&type=style&index=0&id=06cb1a6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb1a6e",
  null
  
)

export default component.exports